// Phase 6-A: レッスンページの「説明文・色凡例」編集パネル
// 旧 LessonContentEditPage（/lesson）が持っていた page_content / color_list 編集を
// コンポーネントとして切り出したもの。統合後の /lesson（LessonManagementPage）から
// マスターモーダルと並ぶ第2モーダルとして開く。
//
// API: get_page_lesson_content / update_page_lesson_content（旧 /lesson と同一）
// 視覚スタイルは既存の course-row-inputs 等を流用。

import React, { useEffect, useState, useCallback } from "react";
import { HexColorPicker } from "react-colorful";

// 1 色エントリの行（旧 LessonContentEditPage の ColorItem を移植）
function ColorItem({ item, index, onChange, onDelete }) {
  const [pickerOpen, setPickerOpen] = useState(false);

  return (
    <div style={{ marginBottom: "0.5rem" }}>
      <div className="course-row-inputs lcp-legend-row">
        <div
          style={{
            width: "18px",
            height: "18px",
            backgroundColor: item.color || "#ffffff",
            border: "1px solid rgba(255,255,255,0.3)",
            borderRadius: "3px",
            cursor: "pointer",
            flexShrink: 0,
            marginLeft: "2px",
          }}
          onClick={() => setPickerOpen((v) => !v)}
        />
        <input
          type="text"
          value={item.color || ""}
          onChange={(e) => onChange(index, "color", e.target.value)}
          placeholder="#60dfff"
          style={{ width: "100px", flexShrink: 0 }}
        />
        <input
          type="text"
          value={item.text || ""}
          onChange={(e) => onChange(index, "text", e.target.value)}
          placeholder="説明（例：小学1年生~初心者クラス）"
          style={{ flex: 1 }}
        />
        <span className="course-remove-btn" onClick={() => onDelete(index)}>
          ×
        </span>
      </div>
      {pickerOpen && (
        <div style={{ marginTop: "0.5rem", paddingLeft: "0.5rem" }}>
          <HexColorPicker
            color={item.color || "#ffffff"}
            onChange={(color) => onChange(index, "color", color)}
            style={{ width: "200px", height: "150px" }}
          />
          <button
            type="button"
            className="color-picker-close"
            style={{ width: "200px", marginTop: "0.5rem" }}
            onClick={() => setPickerOpen(false)}
          >
            完了
          </button>
        </div>
      )}
    </div>
  );
}

const LessonPageContentPanel = ({ onMessage }) => {
  const [pageContent, setPageContent] = useState("");
  const [colorList, setColorList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchContent = useCallback(async () => {
    setLoading(true);
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const res = await fetch(`${apiUrl}/api/get_page_lesson_content/`, {
        method: "GET",
        credentials: "include",
      });
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      const data = await res.json();
      setPageContent(data.page_content || "");
      setColorList(data.color_list || []);
    } catch (error) {
      onMessage?.(`説明文・色の取得に失敗しました: ${error.message}`, "error");
    } finally {
      setLoading(false);
    }
  }, [onMessage]);

  useEffect(() => {
    fetchContent();
  }, [fetchContent]);

  const handleColorChange = (index, field, value) => {
    setColorList((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [field]: value } : item))
    );
  };

  const handleColorDelete = (index) => {
    setColorList((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddColor = () => {
    setColorList((prev) => [...prev, { text: "", color: "#ffffff" }]);
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const res = await fetch(`${apiUrl}/api/update_page_lesson_content/`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ page_content: pageContent, color_list: colorList }),
      });
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      onMessage?.("説明文・色を保存しました", "success");
    } catch (error) {
      onMessage?.(`保存に失敗しました: ${error.message}`, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="lesson-page-content-panel">
      <div className="area3">
        <div className="item">
          <textarea
            value={pageContent}
            onChange={(e) => setPageContent(e.target.value)}
            rows={6}
            style={{ width: "100%", resize: "vertical" }}
            placeholder="IVY DANCE STUDIOでは週に19クラスの初心者クラス🔰を設けているため..."
          />
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", marginTop: "1rem" }}>
        {colorList.map((item, index) => (
          <ColorItem
            key={index}
            item={item}
            index={index}
            onChange={handleColorChange}
            onDelete={handleColorDelete}
          />
        ))}
      </div>

      <div className="accent-wrap">
        <p onClick={handleAddColor} style={{ cursor: "pointer" }}>
          <i className="icon add" />
          <span>Color</span>
        </p>
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "1.25rem" }}>
        <button
          type="button"
          className="lcp-btn lcp-btn--primary"
          onClick={handleSave}
          disabled={loading}
        >
          {loading ? "保存中…" : "保存"}
        </button>
      </div>
    </div>
  );
};

export default LessonPageContentPanel;
